<template>
  <div id="ag-grid-demo">
    <vx-card>
        <div class="flex justify-between items-center">
      <!-- Per Page -->
            <div class="filters-container flex flex-wrap items-center justify-start pb-3">
              <div class="md:mb-0">
                <per-page
                  :currentPerPage="per_page"
                  :pageStart="pageStart"
                  :pageEnd="pageEnd"
                  :total="total"
                  @change-per-page="ChangePerPage($event)"
                />
              </div>
              <div class="md:mb-5 ml-6" style="min-width: 200px">
                <label class="vs-input--label">FROM</label>
                <div>
                  <flat-pickr
                    class="w-100"
                    :config="{
                      ...configdateTimePicker,
                      dateFormat:  'm-d-Y H:i',
                      defaultDate: new Date().setHours(0, 0, 0),
                    }"
                    v-model="start_time"
                    @input="SetDatetimeForStart"
                  />
                </div>
              </div>
              <div class="md:mb-5 ml-6" style="min-width: 200px">
                <label class="vs-input--label">TO</label>
                <div>
                  <flat-pickr
                     class="w-100"
                    :config="{
                    ...configdateTimePicker,
                      dateFormat:  'm-d-Y H:i',
                      defaultDate: new Date().setHours(23, 59, 59),
                    }"
                    v-model="end_time"
                    @input="SetDatetimeForEnd"
                  />
                </div>
              </div>
              <div class="smsc-navigation__col ml-6">
                <vs-button @click="GetList">Sent</vs-button>
              </div>
            </div>

      <!-- Table -->
        </div>
      <div class="flex justify-between items-center">
        <div class="filters-container flex flex-wrap items-center justify-start pb-3">
          <div class="form-group has-search mt-2 widthSearch md:mb-5 ml-6" >
                       <span class="span" @click.stop.prevent="onQuickFilterChanged">
<i
  class="far fa fa-search form-control-smslog-feedback"
>
      </i>
</span>
<!--            <span class="fa fa-search form-control-smslog-feedback " @click="onQuickFilterChanged"></span>-->
            <input
              id="quickFilter"
              placeholder="Search by To"
              v-model="searchProduct"
              class="filter_input_smslog form-control-smslog"
            >
          </div>
          <div class="form-group has-search mt-2 widthSearch md:mb-5 ml-6">
                                  <span class="span" @click="onQuickFilterChangedByDnis">
<i
  class="far fa fa-search form-control-smslog-feedback"
>
      </i>
</span>
<!--            <span class="fa fa-search form-control-smslog-feedback" @click="onQuickFilterChangedByDnis"></span>-->
            <input
              id="quickFilterDnis"
              placeholder="Search by From"
              v-model="dnis"
              class="filter_input_smslog form-control-smslog"
            >
          </div>
          <div class="form-group has-search mt-2 widthSearch md:mb-5 ml-6" >
            <span class="span" @click="onQuickFilterChangedBySMSContent">
<i
  class="far fa fa-search form-control-smslog-feedback"
>
      </i>
</span>
<!--            <span  class="span fa fa-search form-control-smslog-feedback" @click.stop.prevent="onQuickFilterChangedBySMSContent"> &nbsp;</span>-->
            <input
              id="quickFilterTime"
              placeholder="Search by Message"
              v-model="sms_content"
              class="filter_input_smslog form-control-smslog"
            >
          </div>
          <div class="buttons-container flex flex-wrap items-center justify-end mt-1 pb-3">
            <vs-button
              class=" ml-3"
            >Export as CSV</vs-button>
          </div>
        </div>
      </div>
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        :class="{'noDataTable': !list.length}"
        @gridReady="GridReady"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="page"
        @change="pagination($event)"
      />
    </vx-card>
  </div>
</template>

<script>
// Mixins
import TableMixin from '@/mixins/table.js'
import DateTimeMixin from '@/mixins/datetime.js'

// Packages
import vSelect from 'vue-select'
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import flatPickr from 'vue-flatpickr-component'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import 'flatpickr/dist/flatpickr.css'

// Cell Renderer components
// import CellRendererActions from './cell-renderer/CellRendererActions'
// import CellRendererStatus from './cell-renderer/CellRendererStatus'

export default {
mixins: [TableMixin, DateTimeMixin],
  components: {
    AgGridVue,
    flatPickr,
    vSelect,

    // CellRendererLink,
    // CellRendererStatus,
    // CellRendererVerified,
    // CellRendererActions,
  },
  data() {
    return {
      // table header value
      page :1,
      form:0,
      start_time:  new Date().setHours(0, 0, 0),
      end_time:  new Date().setHours(23, 59, 59),
      columnDefs: [
        {
          headerName: 'To',
          field: 'ani',
          sortable: 'ani',
          unSortIcon: true,
          minWidth: 250,
        },
        {
          headerName: 'From',
          field: 'dnis',
          sortable: 'dnis',
          unSortIcon: true,
          minWidth: 250,
        },
        {
          headerName: 'Time',
          field: 'sms_time',
          sortable: 'sms_time',
          unSortIcon: true,
          minWidth: 250,
        },
        {
          headerName: 'Message',
          field: 'sms_content',
          minWidth: 300,
        },
        {
          headerName: 'Country',
          field: '',
          minWidth: 150,
        },
        {
          headerName: 'Operator',
          field: '',
          minWidth: 150,
        },
        {
          headerName: 'Cost',
          field: 'tx_cost',
          minWidth: 150,
        },
        {
          headerName: 'Vendor Result',
          field: 'route_status',
          minWidth: 200,
        },
        {
          headerName: 'Client Result',
          field: 'delivered',
          minWidth: 200,
        },
        {
          headerName: 'Cause of the error',
          field: 'relay_dlr_content',
          minWidth: 200,

        },
      ],
      // Cell Renderer components
      components: {
        // CellRendererActions,
        // CellRendererStatus
      },
      searchProduct: '',
      dnis: '',
      sms_content: '',
      count: 10
    }
  },
  created() {
    this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
    this.filters.start_time = parseInt((new Date(this.start_time).getTime()/1000))
    this.GetList()
    // this.GetListFilterdValue()
  },
  methods: {
    pagination(int) {
        this.from = this.per_page * (this.page - 1)
        this.count = this.total  % 10
        this.count =this.total>this.per_page?this.per_page:this.count
        console.log(this.count,"this.count",this.from,"this.from")
        this.GetList()


    },
    SetDatetimeForEnd() {
      this.filters.end_time = parseInt((new Date(this.end_time).getTime()/1000))
    },
    SetDatetimeForStart() {
      this.filters.start_time = parseInt((new Date(this.start_time).getTime()/1000))
    },
    onQuickFilterChanged() {
      console.log("onQuickFilterChangedByDnis")

      this.filters.ani = this.searchProduct
      this.GetListFilterdValue()
    },
    onQuickFilterChangedByDnis() {
      console.log("onQuickFilterChangedByDnis")

      this.filters.dnis = this.dnis
      this.GetListFilterdValue()
    },
    onQuickFilterChangedBySMSContent() {
      console.log("onQuickFilterChangedBySMSContent")
      this.filters.sms_content = this.sms_content
      this.GetListFilterdValue()
    },
    GetList() {
      this.$vs.loading()
      this.$store.dispatch('log/GetList', {
        ...this.filters,
        count: this.count || 10,
        page: this.page || 0,
        from: this.from,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'sms_time',
        order_dir: this.order_dir || 'desc',
      })
      .then(res => {
        console.log(res,"----------------")
        this.list = res.data.map(this.TransformReseller)
        this.total = res.total
        this.from = res.from
      })
      .catch()
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    GetListFilterdValue() {
      this.$vs.loading()
      this.$store.dispatch('log/GetListFilterdValue', {
        ...this.filters,
        page: 0,
        ani: this.filters.ani || '',
        dnis: this.filters.dnis || '',
        sms_content: this.filters.sms_content || '',
        per_page: this.per_page || 10,
        order_by: this.order_by || 'sms_time',
        order_dir: this.order_dir || 'desc',
      })
      .then(res => {
        console.log(res,"+++++++++++++++")
        this.list = res.data.map(this.TransformReseller)
        this.total = res.total
      })
      .catch()
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    TransformReseller(item) {
      return {
        refreshData: this.GetList,
        ani: item.ani,
        dnis: item.dnis,
        sms_time: format(new Date(item.sms_time * 1000), 'yyyy-dd-MM HH:mm:ss'),
        sms_content: item.sms_content,
        route_status: item.route_status,
        delivered: item.delivered === null ? 'No dlr' : item.delivered,
        tx_cost: item.tx_cost,
        relay_dlr_content: item.relay_dlr_content.split(" ").reverse()[0].split(':')[1]
      }
    },
  }
}
</script>
<style>
    .filter_input_smslog{
        padding: 17px;
        padding-left: 55px;
        width: 300px;
        height: 45px;
        border: 1px solid #f5f5f5;
        font-size: 13px;
        color: gray;
        background-repeat: no-repeat;
        background-position: left center;
        outline: 0;
        margin-top: 2px;
    }
    .has-search .form-control-smslog-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 15px;
        height: 30px;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: gray;
        margin-left: 35px;
        margin-top: 10px;
    }
    .sent-btn {
      margin-right: auto!important;
      padding-top: 10px;
    }
    .order-select-option {
      margin-right: auto!important;
    }
    .widthSearch{
     max-width: 300px!important;
    }
</style>
<style scoped>
  .span{
    position: absolute;
    margin-left: -30px;
    padding-left: 30px;
    width: 81px;
    height: 35px;

  }
</style>
